<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import _capitalize from 'lodash/capitalize';

import { stateNames } from '@/utils/PortalConstants';

export interface Props {
  modelValue?: string | null;
  size?: string;
  loading?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  modelValue: undefined,
  size: 'medium',
  loading: false,
});
const emit = defineEmits<{
  'update:modelValue': [value: (typeof props)['modelValue']];
}>();

const fieldValue = ref(props.modelValue);

watch(
  () => props.modelValue,
  (newModelValue) => {
    fieldValue.value = newModelValue;
  },
);

watch(fieldValue, (newFieldValue) => {
  emit('update:modelValue', newFieldValue);
});

const sizeClass = computed(() => 'size' + _capitalize(props.size));
</script>

<template>
  <v-select
    v-model="fieldValue"
    label="Division"
    :items="stateNames"
    :class="['g-v-text-field', $style.stateSelectField, $style[sizeClass]]"
    data-testid="stateSelectField"
    variant="outlined"
    :base-color="$style.fieldBaseColor"
    :color="$style.fieldColor"
    clearable
    menu-icon="mdi-chevron-down"
  >
  </v-select>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

:export {
  fieldBaseColor: colors.$color-border-input-hovered;
  fieldColor: colors.$color-brand-800;
}

.stateSelectField {
  max-width: 240px;

  :global {
    .v-field__input {
      min-height: 40px;
      font-size: 16px;
      line-height: 22px;
      padding: 9px 16px 7px 16px;
    }
    .v-select__selection {
      margin-top: 0;
    }
    .v-field__outline {
      --v-field-border-width: 1px !important;
    }
  }
}

.sizeSmall {
  :global {
    .v-field__input {
      min-height: 36px;
      font-size: 14px;
      line-height: 20px;
    }
  }
}

.sizeLarge {
  :global {
    .v-field__input {
      min-height: 48px;
      font-size: 18px;
      line-height: 26px;
      padding: 11px 16px 9px 16px;
    }
  }
}
</style>
